// Structural shape shared by the two Price types on the checkout path
// (`@shared/dream-components` for the Link/Payment Request total, `~/interfaces/subscriptions`
// for the CTA). Only the fields this helper reads are declared.
type CheckoutPrice = {
  interval?: string;
  amount_cents?: number;
  premium_offer?: {
    offer_type?: string;
    paid_trial_price_cents?: number | null;
  } | null;
};

// The amount charged today: the paid-trial price when the price carries a paid-trial offer.
// Single source for both the CTA and the Payment Request / Link total, so wallet payments
// don't display (and authorize) the full price instead of the trial price.
const getCheckoutAmountCents = (price: CheckoutPrice | undefined, donationAmountCents: number): number => {
  if (price?.interval === 'donation') return donationAmountCents;
  if (price?.premium_offer?.offer_type === 'trial_period') return 0;
  if (price?.premium_offer?.offer_type === 'paid_trial' && price.premium_offer.paid_trial_price_cents != null) {
    return price.premium_offer.paid_trial_price_cents;
  }
  return price?.amount_cents || 0;
};

export default getCheckoutAmountCents;
